import { Grid, Typography } from '@mui/material';
import { gridSpacing } from 'utils/constants';

const ReportsSavings = () => {
    return (
        <Grid container spacing={gridSpacing}>
            <Grid item xs={12}>
                <Grid container spacing={gridSpacing}>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                        <Typography>Savings Page</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ReportsSavings;
